import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { ModelViewSetting } from '../setting/ModelViewCodeSettting';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
export class ModelViewSceneSimpleBlock extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.MODEL_VIEW_SIMPLE, t.to('シーンスタート', 'scene_start'));
    this.setNameForCode('model-viewer');
    this.setLibraryWithAtt(`type="module" defer`, '../public/libs/model-viewer3.1.1.min.js');
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setSceneColor(block);
    ShapeSettings.setSceneStartShape(block);
    ShapeSettings.setTitleField(block, t.to('平面検知AR', 'plane_detect_ar'));

    const placeType = new Blockly.FieldDropdown([
      [t.to('床に置く', 'place_floor'), 'floor'],
      [t.to('壁に置く', 'place_wall'), 'wall'],
    ]);

    block.appendDummyInput().appendField(t.to('配置', 'place')).appendField(placeType, 'placeType');

    const src = new Blockly.FieldTextInput('');
    ShapeSettings.setTitleField(block, 'src');
    block.appendDummyInput().appendField(src, 'src');
  }

  codeGenerateCore(block: BlockType): string {
    const arModesAtt = CodeSetting.getAttributeCode('ar-modes', `webxr scene-viewer quick-look`);
    const src = CodeSetting.getFieldValue(block, 'src');
    const srcAtt = CodeSetting.getAttributeCode('src', `${src}`);

    const placeType = CodeSetting.getFieldValue(block, 'placeType');

    const arAtt = CodeSetting.getAttributeCode('ar', ``);
    const autoRotateAtt = CodeSetting.getAttributeCode('auto-rotate', ``);
    const autoplayAtt = CodeSetting.getAttributeCode('autoplay', ``);
    const cameraControlsAtt = CodeSetting.getAttributeCode('camera-controls', ``);
    const placeTypeAtt = CodeSetting.getAttributeCode('ar-placement', placeType);

    // ARボタンの外観
    const slotAttr = CodeSetting.getAttributeCode('slot', 'ar-button');
    const styleAttr = CodeSetting.getAttributeCode(
      'style',
      'background-color: ghostwhite;color: gray;border-radius: 6px;' +
        'border: none;position: absolute;bottom: 20%;width: 80%;height: 80px;' +
        'font-size: 24px;right: 10%;font-weight: bold;' +
        'filter: drop-shadow(0 4 20 0 #517c7c 26%);' +
        'visited { color: white; }'
    );

    const ar_button_text = t.to('ARを体験！', 'ar_button');
    const ar_text = CodeSetting.getTextNode(
      `${ar_button_text}<span style="font-size: 24px"> ▷ </span>`
    );

    // AR体験ボタン生成
    const buttonSlot = CodeSetting.getElementCode(
      'button',
      `${slotAttr} ${styleAttr}`,
      '',
      ar_text
    );
    console.log('placeType', placeType);
    //ar-placement="wall"
    const modelViewStr = ModelViewSetting.getModelViewCode(
      this.name_for_code,
      this.libs,

      `${srcAtt}
       ${cameraControlsAtt}
       ${placeTypeAtt}
       ${arAtt}
       ${autoplayAtt}
       ${arModesAtt}
       ${autoRotateAtt}`,

      `${buttonSlot}`,
      placeType
    );
    console.log('modelViewStr', modelViewStr);
    return modelViewStr;
  }
}
